import ConnectWithCollegeModal from './ConnectWithCollegeModal';

export default ConnectWithCollegeModal;



// WEBPACK FOOTER //
// ./src/client/Components/ConnectWithCollegeModal/index.js